// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1g_pK","title":"Header_title__FqDSI","left":"Header_left__2ApL5","clinicName":"Header_clinicName__25vGN"};